<template>
  <div class="flex flex-1 mt-4 items-center">
    <MRow :gutter="0" class="flex-1">
      <MCol :size="3">
        <FlotoApprovalStatusPicker
          class="cursor-text flex"
          :value="value.approvalStatus"
          :placeholder="disabled ? '---' : undefined"
          disabled
          @change="handleChange({ approvalStatus: $event })"
        >
          <template v-slot:trigger="slotData">
            <FlotoDropdownTrigger
              v-bind="slotData"
              :lable="`${$tc('approval')} ${$tc('status')}`"
              icon-name="status"
              disabled
            />
          </template>
        </FlotoApprovalStatusPicker>
      </MCol>
    </MRow>
    <MTag
      v-if="isApproval"
      :closable="false"
      :confirmable="false"
      class="cursor-text"
      style="background-color: var(--page-background-color);"
    >
      {{ $tc('approval') }} {{ $tc('requester') }} :
      <FlotoUserDrawer :user-id="approval.createdById" />
    </MTag>
  </div>
</template>
<script>
export default {
  name: 'ThirdRow',
  model: {
    event: 'change',
  },
  props: {
    disabled: { type: Boolean, default: false },
    value: { type: Object, required: true },
    isApproval: { type: Boolean, default: false },
    approval: { type: Object, default: undefined },
  },
  methods: {
    handleChange(change) {
      this.$emit('change', change)
    },
  },
}
</script>
